import { i18n } from '@lingui/core';
import { t } from '@lingui/macro';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio from '@material-ui/core/Radio';
import classnames from 'classnames';
import React from 'react';
import { connect } from 'react-redux';
import { onChangeParkingsBookingsDateFilter } from '../../../ac/onChangeMapFilters';
import { ParkingsBookingsTypes } from '../../../constants/variables';
import { withDisplayedLayersCheck } from '../../../HOC/withDisplayedLayersCheck';
import { LegendRenderer } from '../../LegendRenderer';
import { PARKINGS_BOOKINGS_DATE_GRADIENT_LEGEND } from '../../../constants/legends';
import { StandardRadioGroup } from '../StandardRadioGroup';
import styles from '../FilterSidebar.module.css';

const ParkingsBookingsDateFilterComponent = ({
    onChangeParkingsBookingsDateFilter,
    parkingsBookingsDateStatuses,
}) => (
    <div>
        <div className={styles.legHead}>{t`Время суток`}:</div>
        <StandardRadioGroup
            value={String(parkingsBookingsDateStatuses)}
            onChange={onChangeParkingsBookingsDateFilter}
        >
            {
                ParkingsBookingsTypes.map(({ value, label }) => (
                    <FormControlLabel
                        key={value}
                        className={styles.isochroneFilterLabel}
                        control={
                            <Radio
                                checked={parkingsBookingsDateStatuses === value}
                                onChange={onChangeParkingsBookingsDateFilter}
                                value={value}
                                className={classnames(
                                    styles.isochroneFilterInput, {
                                        [styles.checkedIsochroneFilterInput]: parkingsBookingsDateStatuses === value,
                                    }
                                )}
                                size='small'
                            />
                        }
                        label={i18n._(label)}
                        labelPlacement='end'
                    />
                ))
            }
        </StandardRadioGroup>
        <LegendRenderer config={PARKINGS_BOOKINGS_DATE_GRADIENT_LEGEND} />
    </div>
);
const mapStateToProps = ({ mapFilters: { parkingsBookingsDateStatuses } }) => ({ parkingsBookingsDateStatuses });
const ConnectedComponent = connect(mapStateToProps, { onChangeParkingsBookingsDateFilter })(ParkingsBookingsDateFilterComponent);

export const ParkingsBookingsDateFilter = withDisplayedLayersCheck(
    ConnectedComponent,
    `${t`Бронирование самокатов на парковке`}`
);
